// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__1KbI3","title":"AfterFrontImage_title__oiR3H"};